<template>
  <div>
    <div class="container" v-if="viewStatus == ''">
      <sticky-top>
        <div class="header">
          <div class="title">项目信息</div>    
         
          <span class="back" @click="back()">
            <i class="iconfont icon-fanhui"></i> 返回
          </span>
        </div>
      </sticky-top>

      <el-row v-for="(gitem,gi) in featuresGroups" :key="gi">
        <el-col :span="3" v-for="(item,i) in gitem" :key="i">
          <el-card :body-style="{ padding: '0px' }" class="card"> <!-- @click.native="onAddClick(item)"-->
            <img :src="item.img" class="image">
            <div style="padding: 14px;text-align: center;">
              <span>{{item.name}}</span>
              <div class="bottom clearfix">
                <!-- <time class="time">{{ currentDate }}</time> -->
                <el-button style="width:40%;" @click="onAddClick(item)">{{item.enable?'移除':'添加'}}</el-button>
                <el-button v-if="item.enable" style="width:40%;" @click="onEditClick(item)">详细</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div v-if="viewStatus == 'lottery_0'">
      <lottery-setting @editClose="editClose"></lottery-setting>
    </div>
    <div v-if="viewStatus == 'lottery_1'">
      <lottery-setting title="卡牌收集" addTitle="添加卡牌" :lotteryType="1" @editClose="editClose"></lottery-setting>
    </div>
    <div v-if="viewStatus == 'winner'">
      <winner-info @editClose="editClose"></winner-info>
    </div>
    <div v-if="viewStatus == 'player'">
      <player-info @editClose="editClose"></player-info>
    </div>
    <div v-if="viewStatus == 'salesman'">
      <salesman-list @editClose="editClose"></salesman-list>
    </div>
    <div v-if="viewStatus == 'message'">
      <message-list @editClose="editClose"></message-list>
    </div>
    <div v-if="viewStatus == 'appy'">
      <appy-list @editClose="editClose"></appy-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import projectApi from '../models/project'
import LotterySetting from './project/lottery/LotterySetting'
import WinnerInfo from './project/player/WinnerInfo'
import PlayerInfo from './project/player/PlayerInfo'
import SalesmanList from './project/salesman/SalesmanList'
import MessageList from './project/message/MessageList'
import AppyList from './project/appy/AppyList'

import lotteryIcon from '@/assets/img/project/lottery.png'
import awardsIcon from '@/assets/img/project/awards.png'
import cardIcon from '@/assets/img/project/cards.png'
import playerIcon from '@/assets/img/project/player.png'
import sellmanIcon from '@/assets/img/project/sellsman.png'
import messageIcon from '@/assets/img/project/message.png'
import appyIcon from '@/assets/img/project/appy.png'

export default {
  components: {
    LotterySetting,
    WinnerInfo,
    PlayerInfo,
    SalesmanList,
    MessageList,
    AppyList,
  },
  data() {
    return {
      viewStatus: '',
      features:[
        {
          key: "lottery_0",
          enable:false,
          data: null,
          name:"抽奖",
          img: lotteryIcon,
        },
        {
          key: "lottery_1",
          enable:false,
          data: null,
          name:"卡牌收集",
          img: cardIcon,
        },
        {
          key: "winner",
          enable:false,
          data: null,
          name:"中奖信息",          
          img: awardsIcon,
        },
        {
          key: "player",
          enable:false,
          data: null,
          name:"参与玩家",
          img: playerIcon,
        },
        {
          key: "salesman",
          enable:false,
          data: null,
          name:"销售人员",
          img: sellmanIcon,
        },
        {
          key: "message",
          enable:false,
          data: null,
          name:"用户留言",
          img: messageIcon,
        },
        {
          key: "appy",
          enable:false,
          data: null,
          name:"申请信息",
          img: appyIcon,
        }
      ],
      featuresGroups: [],
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.loading = false
  },
  methods: {
    ...mapActions(['setFeatureID', 'setFeatures']),
    onQueryChange(query) {
      // 处理带空格的情况
      this.searchKeyword = query.trim()
      this.getDatas()
    },    
    async getDatas() {
      if(this.$store.getters.project < 0) {
        return
      }
      
      try {
        this.loading = true
        const data = await projectApi.getFeature(this.$store.getters.project) || []  

        for(let i in this.features) {
          let feature = this.features[i];
          if(data.indexOf(feature.key) >= 0) {
            let fea = data[feature.key]
            feature.enable = true
            feature.data = fea
          }
        }

        this.group();
        
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },

    group() {
      let colCount = 8;
      this.featuresGroups = [];
      for(let i=0;i<this.features.length;i++) {
        let gi = Math.floor(i / colCount);
        if(this.featuresGroups.length <= gi) {
          this.featuresGroups.push([]);
        }
        this.featuresGroups[gi].push(this.features[i]);
      }
    },

    async onAddClick(item) {
      let res = null;
      try {
        if(item.enable) {
          //remove
          res = await projectApi.removeFeature(this.$store.getters.project, item.key)
        }else{
          //add
          res = await projectApi.addFeature(this.$store.getters.project, item.key)
        }
        if (res.error_code === 0) {
          item.enable = !item.enable
          this.$message.success(`${res.msg}`)
        }else{
          this.$message.error("操作失败！")
        }
      }catch(e){
        this.$message.error("操作失败！")
      }
    },
     onEditClick(item) {
      this.viewStatus = item.key
    },
    editClose() {
      this.viewStatus = '';
      this.getDatas();
    },
    back() {
      this.$router.push('/d_project/project')
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }
}

.card {
  margin: 20px;
  width: 150px;
  height: 250px;
}

.time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 80%;
    display:flex;
    margin: 10%;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

  .back {
    margin-left: 20px;
    cursor: pointer;
  }
</style>
